/**
 * Norva brand marks as inline SVG (no asset pipeline needed, works offline, crisp at any size).
 * Wordmark uses currentColor for the letters (indigo on light, white on dark); the star is always amber.
 * Do not redraw, recolour (other than currentColor) or stretch the logo.
 */
import type { SVGProps } from 'react';

type MarkProps = Omit<SVGProps<SVGSVGElement>, 'children'> & { title?: string };

/** Wordmark, tight viewBox (no outer margin). Set height via CSS; width follows (≈4.04 : 1). */
export function NorvaWordmark({ title = 'Norva', ...rest }: MarkProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="395 320 2847 705" role="img" aria-label={title} {...rest}>
      <path d="M966 1016H852L509 497V1016H395V320H509L852 838V320H966Z" fill="currentColor" />
      <circle cx="1360.0" cy="740.5" r="228.9" fill="none" stroke="currentColor" strokeWidth="107.8" />
      <polygon points="1360.0,600.5 1387.2,713.3 1500.0,740.5 1387.2,767.7 1360.0,880.5 1332.8,767.7 1220.0,740.5 1332.8,713.3" fill="#F59E0B" />
      <path d="M2033 456V574H2004Q1937 574 1902.5 608.0Q1868 642 1868 726V1016H1754V465H1868V545Q1893 503 1934.5 479.5Q1976 456 2033 456Z" fill="currentColor" />
      <path d="M2351 914 2507 465H2628L2418 1016H2282L2073 465H2195Z" fill="currentColor" />
      <path d="M2936 456Q3001 456 3049.5 481.5Q3098 507 3127 545V465H3242V1016H3127V934Q3098 973 3048.0 999.0Q2998 1025 2934 1025Q2863 1025 2804.0 988.5Q2745 952 2710.5 886.5Q2676 821 2676 738Q2676 655 2710.5 591.0Q2745 527 2804.5 491.5Q2864 456 2936 456ZM2960 555Q2916 555 2878.0 576.5Q2840 598 2816.5 639.5Q2793 681 2793 738Q2793 795 2816.5 838.0Q2840 881 2878.5 903.5Q2917 926 2960 926Q3004 926 3042.0 904.0Q3080 882 3103.5 839.5Q3127 797 3127 740Q3127 683 3103.5 641.0Q3080 599 3042.0 577.0Q3004 555 2960 555Z" fill="currentColor" />
    </svg>
  );
}

/** App icon (indigo rounded square, white ring, amber star). Decorative by default. */
export function NorvaAppIcon({ title, ...rest }: MarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      {...rest}
    >
      <rect width="1024" height="1024" rx="230" fill="#312E81" />
      <circle cx="512" cy="512" r="376.3" fill="none" stroke="#FFFFFF" strokeWidth="46.1" />
      <polygon points="512.0,225.3 566.3,457.7 798.7,512.0 566.3,566.3 512.0,798.7 457.7,566.3 225.3,512.0 457.7,457.7" fill="#F59E0B" />
    </svg>
  );
}
